import { RootState } from 'store/reducer';

export const selectRemoteConfig = (state: RootState) => state.remoteConfig;

export const selectRemoteConfigByKey = (key: string) => (state: RootState) => {
  return state.remoteConfig.remoteConfig?.[key];
};
